// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  envName: 'stage',
  //SSO Info for dev
  client_id: '8d9f7544-a7dc-482e-a359-920072b159cf',
  authority: 'https://login.microsoftonline.com' + '/' + 'db05faca-c82a-4b9d-b9c5-0f64b6755421',
  redirectUri: 'https://dqaas-stg.optum.com/',
  cacheLocation: 'localStorage',
  scope: 'user.read',
  resourceMap: 'https://graph.microsoft.com/v1.0/me',
  ssogroupname: 'AZU_DQaaS_SSO_Dev_Users',
  hasuraUrl: 'https://dqaas-stg.optum.com/'
};
